export const ItemTypes = {
  TEAM_NODE: 'team-node',
}
